module.exports = __webpack_public_path__ + "img/alldone.06017f69.svg";